interface CompanyItem {
  label: string;
  value: string;
}

const companyItems: CompanyItem[] = [
  { label: "会社名", value: "株式会社ナンバ" },
  { label: "英語表記", value: "NAMBA Inc." },
  { label: "代表者", value: "代表取締役 難波 伸敏" },
  { label: "設立", value: "2026年8月" },
  { label: "資本金", value: "200万円" },
  { label: "所在地", value: "〒115-0056 東京都北区西が丘2-1-11" },
  { label: "電話番号", value: "03-6454-3314" },
  { label: "メールアドレス", value: "info@namba.ne.jp" },
  {
    label: "受付時間",
    value: "平日 9:30〜18:30（土日祝日・年末年始を除く）",
  },
];

const businessItems = [
  {
    icon: "ri-clipboard-line",
    title: "人材みえる化ソリューション",
    description:
      "人材の適性を科学的に見える化する独自システム「A-SYSTEM」を中心に、スキル・経歴・評価を一元管理し、組織の強みを可視化するソリューションを提供しています。",
  },
  {
    icon: "ri-focus-3-line",
    title: "適性検査事業",
    description:
      "採用・配置・育成の判断をデータに基づいてサポートする適性検査を提供しています。",
  },
  {
    icon: "ri-briefcase-line",
    title: "営業支援事業",
    description:
      "営業の仕組みづくりから成果向上までを一貫して支援しています。",
  },
  {
    icon: "ri-line-chart-line",
    title: "事業支援事業",
    description:
      "人材活用・組織づくりで事業の成長をトータルに支えています。",
  },
];

export default function CompanySections() {
  return (
    <section className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <dl className="font-body text-sm leading-relaxed text-foreground-800">
            {companyItems.map((item, index) => (
              <div
                key={item.label}
                className={`grid grid-cols-1 gap-1 p-5 sm:grid-cols-[12rem_1fr] sm:gap-4 md:p-6 ${
                  index % 2 === 1 ? "bg-background-100/70" : "bg-background-50"
                } ${index !== companyItems.length - 1 ? "border-b border-background-200" : ""}`}
              >
                <dt className="font-label text-sm font-bold text-foreground-950">
                  {item.label}
                </dt>
                <dd className="text-foreground-700">{item.value}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="mt-10">
          <h2 className="font-heading text-xl font-black text-foreground-950">事業内容</h2>
          <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2">
            {businessItems.map((item) => (
              <div
                key={item.title}
                className="rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <div className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                  <i className={`${item.icon} text-lg`} />
                </div>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 font-body text-xs leading-relaxed text-foreground-600">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}